import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../Backend/supabaseClient";

export default function AuthCallback({ setGlobalNotice }) {
  const navigate = useNavigate();
  const [msg, setMsg] = useState("Signing you in…");

  useEffect(() => {
    let cancelled = false;

    const finish = async () => {
      try {
        const { data, error } = await supabase.auth.getSession();

        if (cancelled) return;

        if (error) {
          setMsg("Login failed. Redirecting to login…");
          navigate("/login", { replace: true });
          return;
        }

        if (!data.session) {
          setMsg("No session found. Redirecting to login…");
          navigate("/login", { replace: true });
          return;
        }

        // OPTIONAL: grab name/email for showing a welcome message
        const user = data.session.user;
        const name =
          user.user_metadata?.full_name ||
          user.user_metadata?.name ||
          user.email ||
          "User";

        // If you have a global notice system, you can set it here.
        // Example:
        setGlobalNotice({ type: "success", text: `Welcome, ${name}!` });

        // Choose your post-login destination:
        navigate("/", { replace: true }); // or "/dashboard"
      } catch (e) {
        if (cancelled) return;
        setMsg("Something went wrong. Redirecting…");
        navigate("/login", { replace: true });
      }
    };

    finish();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div style={{ padding: 24 }}>
      <h2>{msg}</h2>
      <p>Please don’t close this tab.</p>
    </div>
  );
}
